export default {"src":"/_next/static/media/doggo_happy.28b0b2c9.svg","height":322,"width":253};